import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomAction } from "../../customAction";
import { Api } from "../../..";
import { IGiveMessageFeedbackRequestParams } from "../../../models/user/InsureAssist/InsureAssist";

export const clearChat = createAsyncThunk(
  "isureAssist/clearChat",
  async (
    { userId, param }: { userId: string; param: string },
    { dispatch }
  ) => {
    await CustomAction(
      Api.get(`ia/${userId}/clear/${param}`),
      dispatch,
      "isureAssist/clearChat"
    );
  }
);

export const giveMessageFeedback = createAsyncThunk(
  "insureAssist/feedback",
  async (
    requestParams: IGiveMessageFeedbackRequestParams,
    { dispatch }
  ) => {
    await CustomAction(
      Api.put(`chat/update-feedback`,requestParams),
      dispatch,
      "insureAssist/feedback"
    );
  }
);
